import React from 'react';
import { IconContainer } from './IconContainer';

const OrgsIcon = ({small, ...props}) => {
    return (
        <IconContainer ariaLabel="orgs" {...props}>
            {small
                ? <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.4999 15.8333H19.1666V17.5H0.833252V15.8333H2.49992V3.33333C2.49992 3.11232 2.58772 2.90036 2.744 2.74408C2.90028 2.5878 3.11224 2.5 3.33325 2.5H11.6666C11.8876 2.5 12.0996 2.5878 12.2558 2.74408C12.4121 2.90036 12.4999 3.11232 12.4999 3.33333V15.8333H15.8333V9.16667H14.1666V7.5H16.6666C16.8876 7.5 17.0996 7.5878 17.2558 7.74408C17.4121 7.90036 17.4999 8.11232 17.4999 8.33333V15.8333ZM4.16658 4.16667V15.8333H10.8333V4.16667H4.16658ZM5.83325 9.16667H9.16658V10.8333H5.83325V9.16667ZM5.83325 5.83333H9.16658V7.5H5.83325V5.83333Z" fill="white"/>
                </svg>
                : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 19H23V21H1V19H3V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H14C14.2652 3 14.5196 3.10536 14.7071 3.29289C14.8946 3.48043 15 3.73478 15 4V19H19V11H17V9H20C20.2652 9 20.5196 9.10536 20.7071 9.29289C20.8946 9.48043 21 9.73478 21 10V19ZM5 5V19H13V5H5ZM7 11H11V13H7V11ZM7 7H11V9H7V7Z" fill="white"/>
                </svg>}
        </IconContainer>
    )
}

export { OrgsIcon };